export const LIVE_CHAT_CONSOLE_QUERY_KEY = 'liveChatConsole';
export const ORG_LIVE_CHAT_CONSOLE_QUERY_KEY = 'orgLiveChatConsole';
